import { FC } from 'react';

import CancelContractButton from '@/components/CancelContractButton/CancelContractButton';
import handleCancellationClick from '@/utils/functions/handleCancellationClick/handleCancellationClick';

import styles from './styles.module.css';

type ContractDetailsHeaderProps = {
  nomProduit: string | null | undefined;
  isCancelable: boolean | null | undefined;
  cancelablePeriod?: number | null;
  manager: string | null | undefined;
  openCancelModal: () => void;
};

const ContractDetailsHeader: FC<ContractDetailsHeaderProps> = ({
  nomProduit,
  isCancelable,
  cancelablePeriod,
  manager,
  openCancelModal,
}) => (
  <div className={styles.titleRow}>
    <h1 className={styles.productName}>{nomProduit}</h1>
    <CancelContractButton
      isCancelable={isCancelable}
      cancelablePeriod={cancelablePeriod}
      onClick={() => handleCancellationClick(manager, openCancelModal)}
    />
  </div>
);

export default ContractDetailsHeader;
